export default __webpack_public_path__ + "static/media/logo.f8a69e07.svg";